import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material';
import KeyboardIcon from '@mui/icons-material/Keyboard';

const KeyboardShortcutsDialog = ({ open, isSmallScreen, onClose }) => (
  <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth fullScreen={isSmallScreen}>
    <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <KeyboardIcon fontSize="small" />
      Keyboard Shortcuts
    </DialogTitle>
    <DialogContent dividers>
      <DialogContentText component="div">
        <Stack spacing={1.25}>
          <Typography variant="body2">
            <strong>Ctrl/Cmd + S</strong>: Save draft locally
          </Typography>
          <Typography variant="body2">
            <strong>Ctrl/Cmd + Z</strong>: Undo
          </Typography>
          <Typography variant="body2">
            <strong>Ctrl/Cmd + Shift + Z</strong> or <strong>Ctrl/Cmd + Y</strong>: Redo
          </Typography>
          <Typography variant="body2">
            <strong>Ctrl/Cmd + Enter</strong>: Execute graph
          </Typography>
          <Typography variant="body2">
            <strong>Ctrl/Cmd + Shift + K</strong>: Open shortcuts help
          </Typography>
        </Stack>
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Close</Button>
    </DialogActions>
  </Dialog>
);

export default KeyboardShortcutsDialog;
